type Partner = {
  identifier: string;
  name?: string;
  url?: string;
  states: Array<string>;
  regionIdentifier?: string;
  logo?: string;
};

export const OPCITY: Partner = {
  identifier: 'opcity',
  name: 'realtor.com®',
  url: 'https://www.realtor.com',
  states: ['CA', 'FL', 'TX'],
};

export const REDFIN: Partner = {
  identifier: 'redfin',
  name: 'Redfin',
  url: 'https://www.redfin.com',
  states: ['IL', 'WA', 'MD'],
  regionIdentifier: 'denial_service_region.redfin',
  logo: '2024-03-1711641703380-04804.jpg',
};

export const MARK_SPAIN: Partner = {
  identifier: 'mark_spain',
  name: 'Mark Spain Real Estate',
  url: 'https://markspain.com',
  states: ['NC'],
  regionIdentifier: 'denial_service_region.mark_spain',
  logo: '2024-03-1711641521282-80407.png',
};

export const PARN: Partner = {
  identifier: 'parn',
  regionIdentifier: 'denial_service_region.parn',
  name: 'top-tier agents nearby',
  states: [],
};

const PARTNERS = [MARK_SPAIN, OPCITY, REDFIN, PARN];

export const checkPartnerByState = (state: string) => {
  return PARTNERS.find((partner) => partner.states.includes(state));
};

export const getPartnerByIdentifier = (identifier: string) => {
  return PARTNERS.find((partner) => partner.identifier === identifier);
};
